module.exports = __webpack_public_path__ + "img/plus-circle.d7850f78.svg";